import { useEffect } from 'react';
import { useGetQuery } from '@/hooks/api/useGetQuery';
import { queryKeys } from '@/queries/query-keys';
import { useAuthStore } from '@/stores/auth-store';

/**
 * GET `/admin/account` on app load — keeps Zustand auth in sync with the cookie session.
 */
export function useSessionBootstrap() {
  const setSession = useAuthStore((s) => s.setSession);
  const setSessionError = useAuthStore((s) => s.setSessionError);

  const query = useGetQuery(() => '/admin/account', {}, queryKeys.session(), {
    retry: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (query.isSuccess && query.data) {
      setSession(query.data);
    }
  }, [query.isSuccess, query.data, setSession]);

  useEffect(() => {
    if (query.isError) {
      setSessionError();
    }
  }, [query.isError, setSessionError]);
}
